<div class="email-otp-step">
  <p class="main-question">
    <strong>Verifica tu correo</strong>
  </p>
  <p class="subtext">Ingresa el código de 6 dígitos enviado a tu correo.</p>

  <!-- Email actual con opción de editar (solo si expiró o hay error) -->
  <div class="email-display">
    <span class="email-label">Correo:</span>
    <strong class="email-value">{{ email }}</strong>
    <button
      *ngIf="isExpired || canResend"
      type="button"
      class="edit-btn"
      (click)="toggleEditEmail()"
      [disabled]="loading"
    >
      <mat-icon>edit</mat-icon>
      Cambiar
    </button>
  </div>

  <!-- Formulario para editar email -->
  <div *ngIf="showEditEmail" class="edit-email-form">
    <form [formGroup]="editEmailForm" (ngSubmit)="saveNewEmail()">
      <input
        type="email"
        formControlName="newEmail"
        placeholder="Nuevo correo electrónico"
        [disabled]="editEmailLoading"
      />
      <div class="edit-email-actions">
        <button
          type="button"
          class="cancel-btn"
          (click)="cancelEditEmail()"
          [disabled]="editEmailLoading"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="save-btn"
          [disabled]="!editEmailForm.valid || editEmailLoading"
        >
          {{ editEmailLoading ? 'Guardando...' : 'Guardar y reenviar' }}
        </button>
      </div>
    </form>
  </div>

  <!-- OTP Input -->
  <div class="otp-section" *ngIf="!showEditEmail">
    <app-otp-input
      #otpInput
      [length]="6"
      [disabled]="loading"
      (codeComplete)="onCodeComplete($event)"
    ></app-otp-input>

    <!-- Countdown o estado expirado -->
    <div class="countdown-section">
      <div *ngIf="!canResend && !isExpired" class="countdown-active">
        <span class="countdown-label">Puedes pedir otro código en:</span>
        <strong class="countdown-time">{{ countdownFormatted }}</strong>
      </div>

      <div *ngIf="isExpired" class="countdown-expired">
        <mat-icon class="warning-icon">warning</mat-icon>
        <span>El código ha expirado</span>
      </div>

      <button
        type="button"
        class="resend-btn"
        [disabled]="!canResend && !isExpired || loading"
        (click)="resendCode()"
      >
        {{ loading ? 'Enviando...' : 'Solicitar nuevo código' }}
      </button>
    </div>

    <!-- Botones de acción -->
    <div class="actions">
      <button
        type="button"
        class="back-btn"
        (click)="goBack()"
        [disabled]="loading"
      >
        Volver
      </button>
    </div>
  </div>
</div>
